module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C129"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_X"
    }
  }), _vm._v("“Papa seems so quietly happy")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "C130"
  }, [_vm._v("—Louisa MacDonald, May 4, 1872, from Deskford (near Cullen)")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("“"), _c('em', [_vm._v("Papa does enjoy this place so much")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "C130"
  }, [_vm._v("—Louisa MacDonald, May 6, 1872 from the Seafield Arms Hotel, Cullen")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("“"), _c('em', [_vm._v("Papa oh! so jolly & bright & happy…Papa was taken for Lord Seafield yesterday")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "C130"
  }, [_vm._v("—Louisa MacDonald, Sept. 2, 1873, from Cullen")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("“"), _c('em', [_vm._v("Papa is very poorly. He ought to go to Cullen for a week I think")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "C130"
  }, [_vm._v("—Louisa MacDonald, October 5, 1873, from London")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e788f10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0005.vue
// module id = 75
// module chunks = 0